module.exports = window.EhsReact.React; 